export const DATA_GRABS = {
    bookerPrimaryColor: 'booker-primary',
    bookerSecondaryColor: 'booker-secondary',
    bookerBackgroundColor: 'booker-background',
    bookerTitle: 'booker-heading',
    bookerSubtitle: 'booker-subheading',
    bookerBody: 'booker-body',
};
